const constrains = {
  identification: {
    presence: {
      message: 'Ingresar una identificación',
      allowEmpty: false,
    },
  },
  amount: {
    presence: {
      message: 'Ingresar la cantidad',
      allowEmpty: false,
    },
  },
  email: {
    presence: {
      message: 'Ingresar un correo',
      allowEmpty: false,
    },
    email: {
      message: 'Formato incorrecto de correo.',
    },
  },
  emails: {
    presence: {
      message: 'Ingresar un correo',
      allowEmpty: false,
    },
    email: {
      message: 'Formato incorrecto de correo.',
    },
  },
  username: {
    presence: {
      message: 'Ingresar el username',
      allowEmpty: false,
    },
  },
  password: {
    presence: {
      message: 'Ingresar la contraseña',
      allowEmpty: false,
    },
    length: {
      minimum: 5,
      message: 'La contraseña debe tener minimo 5 carácteres.',
    },
  },
  phone: {
    presence: {
      message: 'Ingresar un teléfono',
      allowEmpty: false,
    },
    length: {
      minimum: 12,
      message: 'El teléfono debe tener mínimo 12 dígitos',
    },
  },
  startDate: {
    presence: {
      message: 'Ingrese una fecha de inicio',
      allowEmpty: false,
    },
  },
  endDate: {
    presence: {
      message: 'Ingrese una fecha de finalización',
      allowEmpty: false,
    },
  },
  observationsRequest: {
    presence: {
      message: 'Ingrese las observaciones',
      allowEmpty: false,
    },
  },
  observations: {
    presence: {
      message: 'Ingrese las observaciones',
      allowEmpty: false,
    },
  },
  descriptionData: {
    presence: {
      message: 'Ingrese el nombre del departamento',
      allowEmpty: false,
    },
  },
  summary: {
    presence: {
      message: 'Ingrese un resumen',
      allowEmpty: false,
    },
  },
  riskLevelId: {
    presence: {
      message: 'Seleccione el riesgo',
      allowEmpty: false,
    },
  },
  startDateEmployeeDep: {
    presence: {
      message: 'Seleccione una fecha válida',
      allowEmpty: false,
    },
  },
  file: {
    presence: {
      message: 'Seleccione un archivo',
      allowEmpty: false,
    },
  },
};

export type ConstrainNames = keyof typeof constrains;

const getConstrains = (fields: ConstrainNames[]): {} => {
  return fields.reduce(function (result: {[key: string]: {}}, prop: ConstrainNames) {
    result[prop] = constrains[prop];
    return result;
  }, {});
};

export default getConstrains;
